import styled from 'styled-components'
import { theme } from '../../style/theme'

export const PickupMonitorWrap = styled.div`
	font-size: 1rem;
	padding: 1.88em 1.5em 2.5em 2.38em;
	display: grid;
	height: 100%;

	@media screen and (max-width: ${theme.point820}) {
		padding: 1.43em 0.72em;
		gap: 1.43em;
		height: auto;
	}

	@media screen and (max-width: ${theme.point720}) {
		padding: 1.25em;
		gap: 1.25em;
	}
`
PickupMonitorWrap.displayName = 'PickupMonitorWrap'

export const PickupMonitorButtonWrap = styled.div`
	@media screen and (max-width: ${theme.point820}) {
		justify-self: center;

		button {
			width: fit-content;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		justify-self: initial;

		button {
			width: 100%;
		}
	}
`
PickupMonitorButtonWrap.displayName = 'PickupMonitorButtonWrap'
